export const shortcutsInfo = [
  'Select multiple clips - Command/Ctrl',
  'Jump from clip to clip forward - Tab',
  'Jump from clip to clip backward - Shift+Tab',
  'Full screen - F',
  'Out of full screen mode - Esc',
  'Scroll over the clips section by mouse - the scroll wheel top & down for moving left & right',
  'Arrow keys rewind the video 5 sec forward (right key) and backward (left key)',
  'Space bar allows to pause the video',
  'Send selected clip(s) to an existing or new Composer - S',
  'Timeline: move rows - Hold Option/Alt and drag a row',
  'Composer: move rows - Drag the row number to reorder rows',
  'To locate Playhead in timeline press - J',
  'Left/Right arrows: frame-step when paused; jump ±5s when video is playing',
  'Switch directly to an angle - 1, 2, 3, or 4',
  'Cycle through available angles - C',
];
